import { prop } from '@ipfabric/utils/fp/prop';
import type { TableCellContext } from 'components/Table/model/TableCellContext';
import type { TableModel } from 'components/Table/model/TableModel';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectTableCellContext: (s: TableModel) => TableCellContext =
  createScopedSelector(() =>
    createSelector(
      prop('tableCellContext'),
      prop('bulkActions'),
      prop('canRowBeSelected'),
      prop('dispatch'),
      prop('rowIdField'),
      prop('selectedRows'),
      (
        tableCellContext,
        bulkActions,
        canRowBeSelected,
        dispatch,
        rowIdField,
        selectedRows,
      ): TableCellContext => ({
        ...tableCellContext,
        bulkActions,
        canRowBeSelected,
        dispatch,
        rowIdField,
        selectedRows,
      }),
    ),
  );
